import Vuex, {
  MutationTree,
  GetterTree,
  ActionTree,
  Module,
  ActionContext,
} from 'vuex'
import Vue from 'vue'
import { RootState } from '..'
import { IUser } from '@/types'
import cms from '@/cms'
import { CampaignAccount } from 'umg-cms-js-sdk/src/rest/types'

Vue.use(Vuex)

export interface UsersState {
  current: IUser | null
  accessToken: string|null
}

export const usersState: UsersState = {
  current: null,
  accessToken: null,
}

const usersMutations: MutationTree<UsersState> = {
  SET_USER_FROM_CMS_ACCOUNT (state: UsersState, account: CampaignAccount|null) {
    if (!account) {
      state.current = null
      return
    }
    state.current = {
      country: account.country,
      displayName: account.display_name || '',
      email: account.email,
      id: account.id,
      profilePicture: account.profile_picture || '',
      service: account.service,
      serviceId: account.service_id,
    }
  },
  SET_USER_CURRENT (state: UsersState, current: IUser) {
    state.current = current
  },

}

const usersActions: ActionTree<UsersState, RootState> = {
  INIT_USER (ctx: ActionContext<UsersState, RootState>) {
    ctx.commit('SET_USER_FROM_CMS_ACCOUNT', cms.account.currentAccount)
    document.addEventListener('umg:currentAccountChanged', (e) => {
      console.log('CMS ACCOUNT UPDATED')
      ctx.commit('SET_USER_FROM_CMS_ACCOUNT', e.detail)
    })
  },
  LOGIN_SPOTIFY (ctx: ActionContext<UsersState, RootState>) {
    cms.account.loginSpotify()
  },
}

const usersGetters: GetterTree<UsersState, RootState> = {
  userCurrent: (state: UsersState) => state.current,
}

export const usersModule: Module<UsersState, RootState> = {
  state: usersState,
  mutations: usersMutations,
  getters: usersGetters,
  actions: usersActions,
}
